import {
  GetNotificationSettingsResponse,
  UpdateNotificationSettingsRequestBody,
} from "@/types/notification-settings"

import { BaseApi } from "@/lib/base-api"

export class NotificationSettingsApi extends BaseApi {
  async getNotificationSettings() {
    return await this.get<GetNotificationSettingsResponse>(
      "/api/notification-settings"
    )
  }

  async updateNotificationSettings(
    body: UpdateNotificationSettingsRequestBody
  ) {
    return await this.put<GetNotificationSettingsResponse>(
      "/api/notification-settings",
      body
    )
  }

  async resetNotificationSettingsToDefaults(group?: string) {
    const params = group ? { group } : undefined
    return await this.post<GetNotificationSettingsResponse>(
      "/api/notification-settings/reset-to-defaults",
      undefined,
      { params }
    )
  }
}
